import { SET_PROFILE_FIELD } from './actions';

const initialState = {
    profiles: [],
    clicked: false,
    isLoaded: false,
    selected: '',
    selectedData: [],
};

export function profileReducer(state = initialState, action) {
    switch (action.type) {
        case SET_PROFILE_FIELD:
            return { ...state, [action.key]: action.value };
        default:
            return state;
    }
}
